/// <reference path='skyward.ui.controls.js'/>
(
    function(skyward, $, undefined)
    {
        "use strict";
        skyward.specialeducationwi = skyward.specialeducationwi || {};

        var init = function (selector)
        {
            var endDate = $(selector).find(".IEPServiceWIEndDate");
            var exitReasonCodeEELFieldSet = $(selector).find(".SpecialEducationWIStateExitSpecialEducationReason");

            if (endDate.length < 1)
            {
                return;
            }

            var endDateOnChange = function ()
            {
                skyward.specialeducationwi.endDateOnChange(endDate, exitReasonCodeEELFieldSet);
            };

            skyward.specialeducationwi.endDateOnChange(endDate, exitReasonCodeEELFieldSet);
            endDate.on("change", endDateOnChange);
        };

        skyward.specialeducationwi.endDateOnChange = function (endDate, exitReasonCodeEELFieldSet)
        {
            const endDateValue = skyward.controls.getValue(endDate);
            if (endDateValue && endDateValue.isValidDate())
            {
                exitReasonCodeEELFieldSet.show();
            }
            else
            {
                var screenSelector = $("#IEPServiceWIStateExitSpecialEducationReasonWIID_description").length > 0 ? '#IEPServiceWI' : '#editIEPServiceWI_';
                var exitReasonCodeEELCodeValue = $(screenSelector + 'StateExitSpecialEducationReasonWIID_code');
                var exitReasonCodeEELDescriptionValue = $(screenSelector + 'StateExitSpecialEducationReasonWIID_description');
                var exitReasonID = $(screenSelector + 'StateExitSpecialEducationReasonWIID_value');

                exitReasonCodeEELFieldSet.hide();
                skyward.controls.setValue(exitReasonCodeEELCodeValue, "");
                skyward.controls.setValue(exitReasonCodeEELDescriptionValue, "");
                skyward.controls.setValue(exitReasonID, "");
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);